import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { PageHeader, Section, Empty } from "../components/common";
import { fmtDateTime } from "../lib/helpers";

export default function Notifications() {
  const { t, lang } = useLang();
  const [d, setD] = useState(null);
  const load = () => api.get("/notifications").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  return (
    <>
      <PageHeader title={t("Notifications", "Notificaciones")} actions={<><Link to="/more" className="btn-outline btn-sm lg:hidden" data-testid="notifications-menu-link">{t("Menu", "Menú")}</Link><button className="btn-outline btn-sm" onClick={readAll} data-testid="notifications-read-all-btn">{t("Mark all read", "Marcar todo leído")}</button></>} />
      <Section testid="notifications-list">
        {d && !d.items.length && <Empty text={t("No notifications", "Sin notificaciones")} />}
        {d?.items.map((n) => (
          <Link key={n.id} to={n.link || "/"} className={`row-link ${n.read ? "" : "bg-orange-50/60"}`} data-testid={`notification-${n.id}`}>
            {!n.read && <span className="w-2 h-2 rounded-full bg-[#D9531E] shrink-0" />}
            <div className="flex-1"><div className="font-semibold text-sm">{n.message}</div><div className="mono text-xs text-slate-400">{fmtDateTime(n.created_at, lang)}</div></div>
          </Link>
        ))}
      </Section>
    </>
  );
}
